import TotalSpent from "views/admin/dashboard/components/TotalSpent";
import {
  MdBadge,
  MdCancel,
  MdNoteAdd,
  MdOutlineCheckCircle,
} from "react-icons/md";
import Widget from "components/widget/Widget";
import axios from "../../../api/axios";
import React, { useState, useEffect } from "react";
import CheckTableDashboard from "../raport/components/checkTableDashboard";
import { TailSpin } from "react-loader-spinner";
import { columnsDataCheck } from "views/admin/raport/variables/columnsData";

const headerObj = {
  totalPoliceReports: 0,
  totalPoliceApprovedReports: 0,
  totalPoliceRefusedReports: 0,
  administratorOfficers: 0,
};

const PoliceDashboard = () => {
  const [headerData, setHeaderData] = useState(headerObj);
  const [graphData, setGraphData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  const storedToken = localStorage.getItem("token");
  const token = "Bearer " + storedToken?.replace(/"/g, "");
  const headers = {
    Authorization: token,
    "Content-Type": "application/json",
  };

  // ✅ Fetch police dashboard header
  useEffect(() => {
    const fetchHeaderData = async () => {
      try {
        const response = await axios.get("/api/dashboard/getheader-police", {
          headers,
        });
        setHeaderData(response.data);
      } catch (error) {
        console.error("Error fetching police dashboard header:", error);
      }
    };
    fetchHeaderData();
  }, []);

  // ✅ Fetch police graph data
  useEffect(() => {
    const fetchGraphData = async () => {
      try {
        const response = await axios.get("/api/dashboard/getgraph-police", {
          headers,
        });
        setGraphData(response.data);
      } catch (error) {
        console.error("Error fetching police graph data:", error);
      }
    };
    fetchGraphData();
  }, []);

// ✅ Fetch approved Mrepo reports (for table)
useEffect(() => {
  const fetchReports = async () => {
    try {
      const response = await axios.get("/api/reports/approvedMrepo", { headers });
      setData(response.data || []);
    } catch (error) {
      console.error("Error fetching approved Mrepo reports:", error);
    } finally {
      setLoading(false);
    }
  };
  fetchReports();
}, []);

  return (
    <>
      {loading ? (
        <div className="flex items-center justify-center pt-11 mt-11">
          <TailSpin color="#0d9488" height={70} width={70} />
        </div>
      ) : (
        <div>
          {/* ✅ Header */}
          <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-2 2xl:grid-cols-4 3xl:grid-cols-4">
            <Widget
              icon={<MdNoteAdd className="h-7 w-7" />}
              title={"Raportet e pranuara"}
              subtitle={headerData.totalPoliceReports}
            />
            <Widget
              icon={<MdOutlineCheckCircle className="h-6 w-6" />}
              title={"Raportet e miratuara"}
              subtitle={headerData.totalPoliceApprovedReports}
            />
            <Widget
              icon={<MdCancel className="h-6 w-6" />}
              title={"Raportet e refuzuara"}
              subtitle={headerData.totalPoliceRefusedReports}
            />
            <Widget
              icon={<MdBadge className="h-6 w-6" />}
              title={"Officerët administratorë"}
              subtitle={headerData.administratorOfficers}
            />
          </div>

          {/* ✅ Police graph */}
          <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-1">
            {graphData ? (
              <TotalSpent graphData={graphData} /> // 👈 pass police graph data here
            ) : (
              <div className="flex justify-center">
                <TailSpin color="#0d9488" height={50} width={50} />
              </div>
            )}
          </div>

            {/* ✅ Recent Approved Reports */}
             <div className="mt-5 grid grid-cols-1 gap-5 xl:grid-cols-1">
                {Array.isArray(data) && data.length > 0 ? (
                   <CheckTableDashboard
                        columnsData={columnsDataCheck}
                        tableData={data.slice(-5)} // last 5 approved reports
                        redirectPath="/admin/approvedByMrepo"
                    />
                ) : (
                    <div className="text-center py-6 text-gray-600 dark:text-gray-300">
                    Nuk keni raporte të reja
                    </div>
                )}
            </div>
        </div>
      )}
    </>
  );
};

export default PoliceDashboard;
